/** Civil Division – Advice: field captions aligned with data dictionary (steps + review). */
export const CIVIL_ADVISE_FIELD_LABELS = {
  hasPreviousAdvice: 'Has previous advice been received on this matter?',
  previousAdviceAttachment: 'If yes, attach previous advice',
  connectedCaseRelevant: 'Is there any connected case relevant to the advice sought?',
  connectedCaseDetails: 'If yes, include the case details aspect (party details)',
  caseNumber: 'Case Number',
  connectedMatters: 'Are there any connected matters (Advises/Cases)?',
  connectedCaseNumber: 'Connected Case Number',
  connectedAgdFileRef: 'Connected AGD File Reference Number',
} as const;
